export default __webpack_public_path__ + "static/1293-653ebe85d6da8e4ac637c96896438329.gif";